var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"loading":_vm.loading,"outlined":""},on:{"click":_vm.handleDelete}},[_c('MyIcon',{attrs:{"name":"mdi:delete"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }